(function () {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      this.timer = null;

      const endDate = (this.dataset.endDate || '').trim();

      this.endDate = new Date(endDate).getTime();
    }

    connectedCallback() {
      this.timerElement = this.querySelector('.countdown-timer');
      this.expiredElement = this.querySelector('.countdown-expired');

      this.daysElement = this.querySelector('[data-days]');
      this.hoursElement = this.querySelector('[data-hours]');
      this.minutesElement = this.querySelector('[data-minutes]');
      this.secondsElement = this.querySelector('[data-seconds]');

      /*
       * Invalid date / timezone format
       */
      if (Number.isNaN(this.endDate)) {
        console.warn(
          '[CountdownTimer] Invalid end date:',
          this.dataset.endDate
        );

        this.style.display = 'none';
        return;
      }

      this.startCountdown();
    }

    disconnectedCallback() {
      this.stopCountdown();
    }

    startCountdown() {
      this.stopCountdown();

      this.updateCountdown();

      this.timer = window.setInterval(() => {
        this.updateCountdown();
      }, 1000);
    }

    stopCountdown() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    updateCountdown() {
      const distance = this.endDate - Date.now();

      if (distance <= 0) {
        this.showExpired();
        return;
      }

      const days = Math.floor(
        distance / 86400000
      );

      const hours = Math.floor(
        (distance % 86400000) / 3600000
      );

      const minutes = Math.floor(
        (distance % 3600000) / 60000
      );

      const seconds = Math.floor(
        (distance % 60000) / 1000
      );

      if (this.daysElement) {
        this.daysElement.textContent = this.padZero(days);
      }

      if (this.hoursElement) {
        this.hoursElement.textContent = this.padZero(hours);
      }

      if (this.minutesElement) {
        this.minutesElement.textContent = this.padZero(minutes);
      }

      if (this.secondsElement) {
        this.secondsElement.textContent = this.padZero(seconds);
      }
    }

    showExpired() {
      this.stopCountdown();

      if (this.daysElement) {
        this.daysElement.textContent = '00';
      }

      if (this.hoursElement) {
        this.hoursElement.textContent = '00';
      }

      if (this.minutesElement) {
        this.minutesElement.textContent = '00';
      }

      if (this.secondsElement) {
        this.secondsElement.textContent = '00';
      }

      if (this.timerElement) {
        this.timerElement.style.display = 'none';
      }

      if (this.expiredElement) {
        this.expiredElement.style.display = 'block';
      }
    }

    padZero(value) {
      return String(Math.max(0, value)).padStart(2, '0');
    }
  }

  if (!customElements.get('countdown-timer')) {
    customElements.define(
      'countdown-timer',
      CountdownTimer
    );
  }
})();